import path from 'node:path'
import type { ResolvedBetterstartConfig } from '@cli-types/core-engine/config.js'
import type { LoadedSchema } from '@cli-types/core-engine/schema-reader.js'
import type { BetterstartIntegrationId } from '@cli-types/integration-engine/integrations.js'
import { listSchemaNames } from '@core-engine/schema/schema-reader/list-schema-names.js'
import { loadSchema } from '@core-engine/schema/schema-reader/load-schema.js'
import { loadSchemaOwnershipIndex } from '@preset-engine/ownership/load-schema-ownership-index.js'
import { resolveProjectPaths } from '@next-adapter/config/paths/resolve-project-paths.js'
import { schemaManifestContainsMailchimpImports } from './schema-manifest-contains-mailchimp-imports.js'

export function findBlockingIntegrationDependencies(
  cwd: string,
  config: ResolvedBetterstartConfig,
  integrationId: BetterstartIntegrationId
): string[] {
  const blockers: string[] = []
  const paths = resolveProjectPaths(config)
  const schemasDir = path.join(cwd, ...paths.schemasDir.split('/'))
  const ownership = loadSchemaOwnershipIndex(cwd)

  for (const schemaName of listSchemaNames(schemasDir)) {
    if (ownership.schemas[schemaName] !== 'user') {
      continue
    }

    const loaded: LoadedSchema = loadSchema(schemasDir, schemaName)
    if (integrationId === 'mailchimp' && loaded.type === 'form') {
      if (loaded.schema.mailchimp) {
        blockers.push(`${schemaName} still sets "mailchimp" in its form schema`)
        continue
      }

      if (schemaManifestContainsMailchimpImports(cwd, config, schemaName)) {
        blockers.push(
          `${schemaName} still has generated Mailchimp wiring. Run \`betterstart generate ${schemaName}\` before removing the mailchimp integration`
        )
      }
    }
  }

  return blockers
}
